import type { MutationStatus } from "@tanstack/react-query";

import type { FileStatus } from "@/lib/types/file";

import type { PhotoIDUploadStatus } from "../types";

type ComputeStatusParams = {
  hasFile: boolean;
  isValid: boolean;
  uploadMutationStatus: MutationStatus;
  validationStatus: FileStatus;
};

export function computeUnifiedStatus({
  hasFile,
  isValid,
  uploadMutationStatus,
  validationStatus,
}: ComputeStatusParams): PhotoIDUploadStatus {
  // No file selected
  if (!hasFile) return "idle";

  // Upload phase
  if (uploadMutationStatus === "loading") return "uploading";
  if (uploadMutationStatus === "success") return "success";
  if (uploadMutationStatus === "error") return "error";

  // Validation phase
  if (validationStatus === "processing") return "validating";
  if (validationStatus === "invalid-type") return "invalid-type";
  if (validationStatus === "too-large") return "too-large";

  // File is valid and ready to upload or currently being prepared
  // Keep showing validating to prevent flash between validation complete and upload start
  if (validationStatus === "valid" && isValid) return "validating";

  // File is valid but not yet uploaded
  return "idle";
}
